<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card color="success" icon="mdi-water-pump" inline title="Detalle de mediciones por sensor"
      class="px-5 py-3 mb-5">
      <v-row>
        <v-col cols="12" md="4">
          <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones" item-text="name"
            item-value="id" persistent-hint return-object single-line v-on:change="listarEdificios()"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name" item-value="id"
            persistent-hint return-object single-line v-on:change="listarGrupos()"></v-select>
        </v-col>
         <v-col cols="12" md="4">
          <v-select v-model="grupo" outlined :items="grupos" label="Grupos de sensores" item-text="name" item-value="id"
            persistent-hint return-object single-line ></v-select>
        </v-col>
      </v-row>
      <v-row>
      
        <!--
        <v-col cols="12" md="6">
          <v-select v-model="sensor" outlined :items="sensores" label="Sensores" item-text="name" item-value="id"
            persistent-hint return-object single-line></v-select>
        </v-col>
        -->
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="startDate" label="Fecha de inicio" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="startDate" @input="menu1 = false" :max="minimo"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="endDate" label="Fecha de fin" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="endDate" @input="menu2 = false" :max="minimo"></v-date-picker>
          </v-menu>
        </v-col>
         <v-col cols="12" md="4">
          <v-btn color="secondary" @click="listarSensores()">Generar</v-btn>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="12">
          <v-data-table :headers="headersSensores" :items="sensores" sort-by="calories" class="elevation-1"
            :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar" dense>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Sensores</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>

                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
             <template v-slot:item.total_Measure="{ item }">
                  {{ formatNumber(item.total_Measure) }}
                </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Recargar </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="listar(item)">
                    <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>


    </base-material-card>
    <v-dialog v-model="dialogDetails" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="dialogDetails = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalles del sensor</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" lg="12">
              <line-chart
                v-if="consolidadores.length"
                :chart-data="lineChartData"
                :options="lineChartOptions"
              />
            </v-col>
          </v-row>
          <!--
          <v-row>
            <v-col cols="12" lg="12">
              <v-data-table :headers="headers" :items="consolidadores" sort-by="calories" class="elevation-1"
                :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar" dense>
              
              </v-data-table>
            </v-col>
          </v-row>
          -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { Line } from "vue-chartjs";
export default {
  name: "DashboardExtendedTables",
  components: {
    'line-chart': {
      extends: Line,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options);
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options);
        }
      }
    }
  },
  data: () => ({
    urbanizaciones: [],
    urbanizacion: [],
    edificios: [],
    edificio: [],
    grupos: [],
    grupo: [],
    headersSensores: [
      { text: "Nombre", value: "name" },
      { text: "Medida", value: "total_Measure" },
      { text: "Unidad", value: "unit_of_measurement" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    sensores: [],
    sensor: [],
    dialogDetails: false,

    headers: [
      { text: "Fecha", value: "sumDate" },
      { text: "Total", value: "sumMeasure" },
    ],
    consolidadores: [],

    loadingTableDetails: false,
    searchDetails: "",
    menu1: false,
    menu2: false,
    startDate: new Date(Date.now()).toISOString().substr(0, 10),
    endDate: new Date(Date.now()).toISOString().substr(0, 10),
    minimo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),

    search: "",
    loadingTable: false,
    snackbar: false,
    text: "",
    timeout: 6000,
    transformedData: [],
    maxSumMeasure: 0,
    data: {
      labels: [''],
      series: [
        [0],

      ],
      
    },
    emailsSubscriptionChart: {
      options: {
        axisX: {
          showGrid: TextTrackCueList,
        },
        low: 0,
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0,
        },
      },
      responsiveOptions: [
        ['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0]
            },
          },
        }],
      ],
    },

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo periodo" : "Editar periodo";
    },
     lineChartData() {
      return {
        labels: this.consolidadores.map(item => item.sumDate.replace('T00:00:00', '')),
        datasets: [
          {
            label: 'Consumo',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            fill: false,
            data: this.consolidadores.map(item => item.sumMeasure)
          }
        ]
      };
    },
    lineChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        title: {
          display: true,
          //text: 'Consumo por fecha'
        },
        legend: {
          display: true
        }
      };
    }

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listarUrbanizaciones();
    },
     formatNumber(value) {
      return parseFloat(value).toFixed(2);
    },
    listarGrupos() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Groups", configuracion)
        .then(function (response) {
          me.grupos = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarSensores() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Sensors/SensorByGroup/" + me.grupo.id + "/" + me.edificio.id + "/" + me.startDate + "/" + me.endDate, configuracion)
        .then(function (response) {
          me.sensores = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarUrbanizaciones() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Communities", configuracion)
        .then(function (response) {
          me.urbanizaciones = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarEdificios() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.edificios = [];
      axios
        .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
        .then(function (response) {
          me.edificios = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listar(item) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.dialogDetails = true;
      axios
        .post(
          "api/Measures/SensorDateSum",
          {
            sensor_uq: item.id,
            startDate: me.startDate,
            endDate: me.endDate,
          },
          configuracion
        )
        .then(function (response) {
          console.log(response.data);
          me.consolidadores = response.data;
          //transformar grafico
          me.consolidadores.forEach(item => {
            item.sumDate = item.sumDate.replace('T00:00:00', '');
          });
          const transformedData = {
            data: {
              labels: me.consolidadores.map(item => item.sumDate),
              series: [
                me.consolidadores.map(item => item.sumMeasure)
              ]
            }
          };
          //me.maxSumMeasure = Math.max(...me.consolidadores.map(item => item.sumMeasure));
          me.data = transformedData.data;
        }

        )


        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
  },
};
</script>